import AuthSubmit from "components/v2/Auth/AuthSubmit";
import AuthLink from "components/v2/Auth/AuthLink";
import useLogin from "api/UserResource/useLogin";
import FormField from "components/v2/Auth/AuthField";
import SocialLoginButtons from "components/v2/Auth/SocialLoginButtons";
import { Form, Formik } from "formik";
import AuthLayout from "layouts/AuthLayout";
import * as Yup from "yup";
import { deviceIdentifiers } from "utils";
import { useRef, useState } from "react";
import AuthHeading from "components/v2/Auth/AuthHeading";

const Login = () => {
	const [formError, setFormError] = useState("");
	const [captchaValue, setCaptchaValue] = useState("");
	const recaptchaRef = useRef(null);


	const resetCaptcha = () => {
		recaptchaRef.current?.reset();
		setCaptchaValue("");
	};

	const { os, browser } = deviceIdentifiers();

	const initialValues = {
		username: "",
		password: "",
	};

	const loginSchema = Yup.object().shape({
		username: Yup.string().required("Username/email is required"),
		password: Yup.string().required("Password required"),
	});

	const { mutateAsync, isLoading } = useLogin();
	const handleLogin = async (data) => {
		setFormError("");
		try {
			await mutateAsync({
				...data,
				os,
				browser,
				captcha: captchaValue,
			});
		} catch (error) {
			setFormError(error?.response?.data?.message || "We couldn't log you in. Check your details and try again.");
			resetCaptcha();
		}
	};

	return (
		<AuthLayout>
			<AuthHeading heading="Welcome back" subheading="Log in to your library and pick up where you left off." />
			<SocialLoginButtons dividerPlacement="below" />
			<Formik initialValues={initialValues} onSubmit={handleLogin} validationSchema={loginSchema}>
				<Form className="auth-login" noValidate>
					<FormField name="username" label="Email or username*" placeholder="you@example.com" autoComplete="username" />
					<div>
						<div className="auth-password-label">
							<AuthLink mode="password-reset">Forgot password?</AuthLink>
						</div>
						<FormField name="password" type="password" label="Password*" placeholder="Enter your password" autoComplete="current-password" />
					</div>
					{formError && <p className="auth-form-error" role="alert">{formError}</p>}
					<AuthSubmit captchaRef={recaptchaRef} captchaValue={captchaValue} onCaptchaChange={(value) => setCaptchaValue(value || "")} isLoading={isLoading} label="Log in" loadingLabel="Logging you in…" />
				</Form>
			</Formik>
		</AuthLayout>
	);
};

export default Login;
